import { put } from 'redux-saga/effects'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getSelectedDataFromObject } from '../../../../../utilities/data.util'
import { initialPulsesState } from '../store/pulses.reducer'
import { setPulses } from '../store/pulses.actions'

export function* getPulses(pcrDoc: IPcr) {
  if (pcrDoc && pcrDoc.prNabc) {
    const prNabc = pcrDoc.prNabc
    const pulsesItems = getSelectedDataFromObject(prNabc, Object.keys(initialPulsesState))
    const pulses = {
      ...pulsesItems,
    }
    if (pulses && Object.keys(pulses).length !== 0) {
      yield put(setPulses(pulsesItems))
    }
  }
}
